import { Image } from 'expo-image';
import { useEffect } from 'react';
import Animated, {
  ReduceMotion,
  useAnimatedStyle,
  useSharedValue,
  withDelay,
  withRepeat,
  withSequence,
  withTiming,
} from 'react-native-reanimated';
import { View, YStack } from 'tamagui';

import PSText from '@/components/ui/PSText';
import PSBox from './ui/PSBox';

const EYES_WIDTH = 44;
const EYES_ASPECT = 44 / 42;
// Fast enough that the mid-fade frame (both pupils at half strength) doesn't
// register — it reads as a dart, not a dissolve.
const DART_MS = 90;

// 0 = looking left, 1 = looking right. Uneven holds so the loop doesn't feel
// metronomic.
const dart = (to: 0 | 1, holdMs: number) =>
  withDelay(
    holdMs,
    withTiming(to, { duration: DART_MS, reduceMotion: ReduceMotion.System })
  );

function LookingEyes() {
  const lookRight = useSharedValue(0);

  useEffect(() => {
    lookRight.value = withRepeat(
      withSequence(dart(1, 1800), dart(0, 1100), dart(1, 500), dart(0, 400)),
      -1
    );
  }, [lookRight]);

  const rightStyle = useAnimatedStyle(() => ({ opacity: lookRight.value }));
  const leftStyle = useAnimatedStyle(() => ({ opacity: 1 - lookRight.value }));

  return (
    <View width={EYES_WIDTH} aspectRatio={EYES_ASPECT}>
      <Animated.View style={[{ position: 'absolute', inset: 0 }, leftStyle]}>
        <Image
          source={require('@/assets/images/left-eye.png')}
          style={{ flex: 1 }}
          contentFit="contain"
        />
      </Animated.View>
      <Animated.View style={[{ position: 'absolute', inset: 0 }, rightStyle]}>
        <Image
          source={require('@/assets/images/right-eye.png')}
          style={{ flex: 1 }}
          contentFit="contain"
        />
      </Animated.View>
    </View>
  );
}

export default function APEmptySection() {
  return (
    <PSBox
      bg="$color.brand"
      borderWidth="$borderWidth.hairline"
      borderColor="$color.panelTranslucent"
      gap="$space.xl"
      p={'$space.lg'}
    >
      <LookingEyes />
      <YStack gap="$space.sm">
        <PSText.H1 color="$color.textWhite">
          Nothing here right now :(
        </PSText.H1>
        <PSText.Body2 color="$color.textWhite">
          Some great new member only experiences are coming your way.
        </PSText.Body2>
      </YStack>
    </PSBox>
  );
}
